import React from 'react';
import { deriveFileState } from './ActiveFileProgressRow';

/**
 * Compact progress readout for one row of the ingest queue/history table --
 * same underlying data as IngestProgressPanel's full view (progress.activeFiles),
 * just condensed to a single line since a table row has no room for one bar
 * per in-flight file. Previously this showed `liveProgress.currentFile`, a
 * single field that whichever of the COPY_CONCURRENCY workers happened to
 * report last kept overwriting -- it named one file while up to four others
 * were also actively copying, and said nothing once that file finished
 * copying and moved into checksum verification. Deriving a small summary
 * from the same activeFiles array ScanAndOffload's full view uses fixes both.
 */
export default function LiveJobMiniProgress({ c, pct, activeFiles }) {
  const files = activeFiles || [];
  const copyingCount = files.filter((f) => deriveFileState(f) === 'copying').length;
  const verifyingCount = files.filter((f) => deriveFileState(f) === 'verifying').length;

  const parts = [];
  if (copyingCount > 0) parts.push(`${copyingCount} copying`);
  if (verifyingCount > 0) parts.push(`${verifyingCount} verifying`);
  const summary = parts.length > 0 ? parts.join(' · ') : (files[0]?.relativePath || '');

  return (
    <>
      <div style={{ height: '5px', marginTop: '5px', borderRadius: '3px', background: c.rule, overflow: 'hidden' }}>
        <div style={{ height: '100%', width: `${pct}%`, background: c.accent, transition: 'width 0.15s linear' }} />
      </div>
      <div title={summary} style={{ color: c.muted, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {pct}%{summary ? ` · ${summary}` : ''}
      </div>
    </>
  );
}
